/* eslint-disable @typescript-eslint/no-explicit-any */
import { throttleIfPossible } from "@faire/web/common/globals/throttleIfPossible";

const THROTTLE_TIME = 250;

// This is a patch to reduce multiple api calls made at very short span of time
// (could a mouse issue, keyboard issue, not necessarily bad user behavior)
// we should have a more robust solution (but more expensive in terms of time development)
// but to give us some room to brief we are using a FE throttle
// This is the proper way to specify any function

export const commonThrottle = <T extends (...args: any) => any>(func: T): T => {
  const throttled = throttleIfPossible(func, THROTTLE_TIME);

  return ((...args: any): any => {
    return throttled(...args);
  }) as T;
};
